export const POLICY_STRINGS = {
    ADD_POLICY: "Add Policy",
    EDIT_POLICY: "Edit Policy",
    POLICY_ID: "Policy Id",
    POLICY_NAME: "Policy Name",
    SEARCH_POLICY: "Search Policy",
    TYPE: "Type",
    EXPIRES_AFTER: "Expires After",
    MIN_OFFERS: "Min Offers",
    MAX_OFFERS: "Max Offers",
    OFFER_EXPIRES_DEFAULT_VALUE: "Default value will be 60",
    MIN_OFFERS_DEFAULT_VALUE: "Default value will be 1",
    MAX_OFFERS_DEFAULT_VALUE: "Default value will be 3",
};

export const POLICY_KEYS = {
    ID: "id",
    POLICY_NAME: "policyname",
    MODE_KIND: "modeKind",
    OFFER_EXPIRES: "offerExpiresAfterSeconds",
    MIN_OFFERS: "minConcurrentOffers",
    MAX_OFFERS: "maxConcurrentOffers",
};

export const POLICY_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "Policy ID" },
    { id: "policyname", isSortable: true, label: "Policy Name" },
    { id: "modeKind", isSortable: true, label: "Type" },
    { id: "offerExpiresAfterSeconds", isSortable: true, label: "Expires After" },
    { id: "minConcurrentOffers", isSortable: true, label: "Min Offers" },
    { id: "maxConcurrentOffers", isSortable: true, label: "Max Offers" },
];

export const POLICY_TYPES = [
    {id:"roundRobin", label: "Round Robin"},
    {id:"longestIdle", label: "Longest Idle"}
];

export const POLICY_TABLE_COLUMN_KEYS = {
    ID: "id",
    ACTIONS: "actions",
    POLICY_NAME: "policyname",
    MODE_KIND: "modeKind",
    OFFER_EXPIRES: "offerExpiresAfterSeconds",
    MIN_OFFERS: "minConcurrentOffers",
    MAX_OFFERS: "maxConcurrentOffers",
};

export const POLICY_MESSAGES = {
    NO_POLICY: "No policy to display",
    POLICY_ADDED: "Policy added successfully!",
    POLICY_UPDATED: "Policy updated successfully!",
};

export const POLICY_ERRORS = {
    ADD_POLICY_ERROR: "Error adding policy:",
    SAVE_POLICY_ERROR: "Error saving policy:",
    UPDATE_POLICY_ERROR: "Error updating policy:",
    FETCH_POLICY_ERROR: "Error fetching policy:",
    DELETE_POLICY_ERROR: "Error deleting distribution policy",
};